import axios from 'axios';

// L'url de l'API
const API_URL = "https://2501.ict-expert.ch/api";

const getHeader = () => {
    const token = localStorage.getItem('user_token');
    return token ? { headers: { Authorization: token } } : {};
};

export const api = {
    // authentification
    login: (email, password) => axios.post(`${API_URL}/auth/login`, { email, password }),
    register: (email, password) => axios.post(`${API_URL}/auth/register`, { email, password }),
    
    // tasks
    getTasks: () => axios.get(`${API_URL}/tasks`, getHeader()),
    addTask: (task) => axios.post(`${API_URL}/tasks`, task, getHeader()),
    updateTask: (task) => axios.put(`${API_URL}/tasks`, task, getHeader()),
    deleteTask: (id) => axios.delete(`${API_URL}/tasks?id=${id}`, getHeader()),

    // categorie
    getCats: () => axios.get(`${API_URL}/categories`, getHeader()),
    addCat: (name, color) => axios.post(`${API_URL}/categories`, { name, color }, getHeader()),
    updateCat: (category) => axios.put(`${API_URL}/categories`, category, getHeader()),
   deleteCat: (id) => axios.delete(`${API_URL}/categories?id=${id}`, getHeader())
};